/* unplugin-vue-components disabled */import { render } from "./Vars.vue?vue&type=template&id=483d77f2"
const script = {}

import exportComponent from "/builds/eb-football/footy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__